import React from 'react';

const PencilIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon-wrap"
    viewBox="0 0 30 30"
    width="16px"
    height="16px"
  >
    <path
      fill="#677892"
      d="M18.7 5.1l6.1 6.1L9.3 26.6l-6.1-6.1L18.7 5.1zm10.7-1.5L26.7.9c-1.1-1.1-2.8-1.1-3.8 0l-2.6 2.6 6.1 6.1 3-3c.8-.9.8-2.2 0-3zM0 29.1c-.1.5.3.9.8.8l6.8-1.6-6.1-6.1L0 29.1z"
    />
  </svg>
);

export default PencilIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/PencilIcon.js